// extracted by mini-css-extract-plugin
export default {"root":"AppShell_root__rNV68"};